<template>
  <div class="appointment-details">
    <div class="border-line" :style="{backgroundColor: appointment.TypeColor}"></div>
    <div class="header">
      <h1 class="header-text">
        <span>
          {{ appointment.Type }}
          <div :style="{backgroundColor: appointment.TypeColor}" class="header-text-line"></div>
        </span>
      </h1>
    </div>
    <div class="content clearAfterFloats">
      <div>
        <p class="studio">{{ appointment.Studio }}</p>
        <p>
          <v-icon :style="{color: appointment.TypeColor}">access_time</v-icon>
          <span>{{ appointment.Time }}</span>
        </p>
        <p>
          <v-icon :style="{color: appointment.TypeColor}">date_range</v-icon>
          <span>{{ appointment.Date }}</span>
        </p>
      </div>
      <div class="btns-large">
          <div 
          :style="{backgroundColor: appointment.TypeColor}"
          class="button">
              <v-icon>edit</v-icon>
              Uredi
          </div>
          
          <div 
          v-if="$store.state.services.checkRole('Administrator') || appointment.CreatedByUser"
          @click="deleteAppointment"
          class="button">
              <v-icon>delete_forever</v-icon>
              Delete
          </div>
      </div>
     
    </div>
     <div class="users clearAfterFloats">
          <div 
          v-for="user in appointment.Attendands"
          :key="user.Name"
          class="user">
              <span 
              class="profile-picture"
              :style="{ backgroundImage: 'url(' + user.ProfileUrl + ')' }"></span>
              <span class="name">{{ user.Name }}</span>
          </div>
      </div>
      <div 
      v-if="$store.state.services.checkRole('Administrator') || appointment.CreatedByUser"
      @click="deleteAppointment"
      class="btns-small">
        Izbriši
      </div>
  </div>
</template>

<script>
export default {
  props: ["appointmentId"],
  data() {
    return {
      appointment: {}
    };
  },
  methods:{
      getAppointment(){
          this.$store.state.services.appointmentService
          .get(this.appointmentId, parseInt(localStorage.getItem("user")))
          .then(response => {
              this.appointment = response.data;
          })
      },
      deleteAppointment(){
          this.$store.state.services.appointmentService
          .remove(this.appointmentId, parseInt(localStorage.getItem("user")))
          .then(response => {
              this.$emit("deleteAppointment",response.data);
          })
      }
  },
  watch: {
    appointmentId(){
        if(this.appointmentId !== null){
            this.getAppointment();
        }
    }
  },
};
</script>

<style scoped>
.appointment-details{
    background-color: white;
    color: #657786;
    border-radius: 20px;
    position: relative;
    padding: 20px 10px 20px 40px;
}
.border-line{
    height: 90%;
    width: 6px;
    border-radius: 20px;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
}
.studio {
    font-size: 18px;
    font-weight: 400;
}
.content{
    padding-top: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(0,0,0,.12);
    margin-bottom: 10px;
}
.content i{
    font-size: 18px;
}
.content p span{
    font-weight: 500;
}
.content div{
    width: 50%;
    float: left;
}
.btns-small{
    display: none;
    text-transform: uppercase;
    color:#ff3b30;
    text-align: right;
    padding-right: 10px;
    padding-bottom: 10px;
    font-weight: 500;
    cursor: pointer;
    margin-top: 20px;
}
.button{
    padding: 10px 20px;
    border-radius: 30px;
    width:auto !important;
    color:white;
    margin: 0 10px;
    cursor: pointer;
    transition: all .3s;
}
.button:nth-child(1){
    display: none;
}
.button:nth-child(2){
    color:black;
    border:1px solid #657786;
}
.button:nth-child(2):hover{
    background-color: #ff3b30;
    color:white;
    border:none;
}
.button:nth-child(2):hover i{
    color:white;
}
.button i{
    color:white;
    margin-right:5px;
}
.button:nth-child(2) i{
    color:black;
}
.user{
    width: 25%;
    float: left;
    padding: 5px 10px;
}
.user span{
    display: inline-block;
}
.profile-picture{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-size: cover;
    background-position: center;
}
.name{
    vertical-align: top;
    line-height: 50px;
    margin-left: 15px;
    font-size: 16px;
}
@media only screen and (max-width: 768px) {
  /* For mobile phones: */
    .appointment-details{
        padding: 10px 10px 5px 20px;
    }
    .border-line{
        width: 5px;
    }
    .content div{
        width: 100%;   
    }
    .btns-large{
        display: none;
    }
    .btns-small{
        display: block;
    }
    .user{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .profile-picture{
        width: 30px;
        height: 30px;
    }

}
</style>
